import {clone} from 'lodash';
import us from '../../defines';
import {Rectangle} from '../../lib/objects/';
import {divRotate} from '../../lib/utility/helpers';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('uScope.extensions.scalebar');

const defaults = {
  layout: {'divClass': us.clsDIVOUTERSCALEBAR, 'precinct': 'BR', 'order': 2, 'canBePlaced': true}
};

export default function ScaleBarControl (uScope, viewport, userConfig) {
  var self = this;
  var isLoaded = false; // scale bar has been 'loaded'

  var jVpDiv = viewport.vpDivGet('outer');
  var jScaleBarOuter; // the outer div - implemented to manage the scale bar rotation
  var jScaleBar; // the inner div
  var jTextDiv;
  var jMagDiv;
  var jRotateKnob;
  var jKnobText;

  var scaleBarSpecs = { // scale bar settings
    'minWidth': 60,
    'minHeight': 20, // resize limits
    'maxWidth': 1000,
    'maxHeight': 20,
    'micronsAt20x': 50, // initial scale report, overridden by scaleBar resize
    'micronsAt40x': 25, // initial scale report, overridden by scaleBar resize
    'micronsAt100x': 25 // initial scale report, overridden by scaleBar resize
  };
  var bReportPixels_ = false; // report scale bar length in pixels instead of microns

  var scaleLenMicCur_; // current scale bar length in microns
  var bIsFitZoomCur_; // true/false current zoom is fit zoom
  var angleDeg = 0.0; // current rotation angle of scale bar
  var crBox_ = new Rectangle(0, 0, 1, 1); // bounding box of rotated scale bar

  var navModesImHiddenIn = {}; // what navigation modes not to display the label

  var layout = clone(defaults.layout);
  var reLayout = viewport.overLayout.refreshPrecinct;

  var construct_ = function () {
    if (us.ENABLESCALEBAR == false) return; // if the scalebar has been disabled, don't load it

    navModesImHiddenIn[us.eNavModes.nmRasterScan] = true;// hide scale bar in rasterscan mode
    load_(); // load the scalebar
  };

  self.show = function (bShow) {
    if (isLoaded == false) {
      return;
    }

    // prevent show if preference is not to show
    if (userConfig.get(us.clsDIVSCALEBAR) == false) jScaleBarOuter.hide();
    else if (bShow == true) jScaleBarOuter.show();
    else jScaleBarOuter.hide();

    reLayout(layout.precinct); // layout just this overlay's precinct
  };

  // ............................................ resize() public
  // This function resizes the scale bar.
  // parameters:
  //        action:    'zoom' or 'resize' (default if undefined)
  //
  //    Note: the scalebar's inner div's width is set by that of the outer div even though the
  //            resize event handler is on the inner div.  This solved a problem that the resize
  //            cursor seemed to lead the element and stop resize unless you drag slowly.
  self.resize = function (action) {
    if (us.ENABLESCALEBAR == false || isLoaded == false) return;

    // note that a zoom change of fit to fit is handled as a resize
    //    b/c the previous zoom is really the double click (toggle zoom) value
    if (action == 'zoom' && bIsFitZoomCur_ == true && viewport.isFitZoom() == true) { action = 'resize'; }

    // the cause of the resize event is used to choose the approach to updating the scalebar text
    var zoom = viewport.getViewZoom();
    var MPP = viewport.getBaseMPP() * zoom; // microns/pixel = base level microns/pixel x current zoom
    var scaleLenMic;
    var scaleBarLenPx;
    if (action == 'zoom') { //    - on an action of zoom the scale bar length in MICRONS is the reference
      scaleLenMic = scaleLenMicCur_ * zoom / viewport.getViewPrevZoom();
      scaleBarLenPx = scaleLenMic / MPP; // scale bar length in pxiels - for this zoom
    } else { //    - on action of user resize the scale bar length in PIXELS is the reference
      scaleBarLenPx = jScaleBarOuter.width(); // the outer div defines the width
      jScaleBar.width(scaleBarLenPx); // set the inner div width to that of the outer
      scaleLenMic = scaleBarLenPx * MPP; // scale bar length in microns
    }

    if (scaleLenMicCur_ == scaleLenMic) { // if nothing has changed, return now
      return;
    }

    jMagDiv.text(viewport.getViewMag() + 'x'); // update the mag report
    if (bReportPixels_ == true) {
      jTextDiv.text(Math.round(scaleBarLenPx) + ' px'); // update the scale report in pixels
    } else {
      jTextDiv.text(Math.round(scaleLenMic) + ' um'); // update the scale report in microns
    }

    scaleLenMicCur_ = scaleLenMic; // save the current state info
    bIsFitZoomCur_ = viewport.isFitZoom();
  };

  // ............................................ rotate() public
  //    This function rotates the scale bar to the speicified absolute or relative (incremental) angle.
  //    parameters:
  //        nDegrees    : angle in degrees
  //        relOrAbs    : { 'relative or 'absolute' }
  //                        if 'relative' the label is rotated the current angle + nDegrees clockwise
  //                        if 'absolute' the label is rotated nDegrees clockwise
  self.rotate = function (nDegrees, relOrAbs) {
    angleDeg = (relOrAbs == 'relative') ? (+angleDeg + nDegrees) % 360 : +nDegrees;
    divRotate(jScaleBar[0], 0, 0, jScaleBar.width(), jScaleBar.height(), angleDeg * us.Deg2Rad);
    angleTextWrite_();
  };

  // ............................................ rotateToCursor() public
  //    This function rotates the scale bar to the angle of the cursor with the scale bar center.
  self.rotateToCursor = function (e) {
    if (viewport.navModeGet() == us.eNavModes.nmRotatingOverlay) {
      var thisAngleRad = Math.atan2(-(crBox_.cy - e.pageY), e.pageX - crBox_.cx);

      if (thisAngleRad > us.PI_2) thisAngleRad = us.PI_2;// limit the rotation between -90 to +90 degrees
      else if (thisAngleRad < -us.PI_2) thisAngleRad = -us.PI_2;
      var thisAngleDeg = (thisAngleRad * us.Rad2Deg).toFixed(2);
      if (Math.abs(thisAngleDeg - angleDeg) < 0.5) { // if the angle hasn't changed much, do nothing
        return;
      }

      divRotate(jScaleBar[0], 0, 0, jScaleBar.width(), jScaleBar.height(), thisAngleRad);
      angleDeg = thisAngleDeg; // save current scalebar angle
      angleTextWrite_(); // update angle readout
    }
  };
  // ............................................ angleTextWrite_() local
  var angleTextWrite_ = function () {
    var str = '<p>' + Math.round(angleDeg) + '<sup>o</sup></p>';
    jKnobText.html(str);
  };
    // ............................................ crBoxSet_() local
    // This function sets the bounding box of the rotated scale bar.
  var crBoxSet_ = function () {
    let offset;
    if (angleDeg == 0.0) {
      offset = jScaleBar.offset();
      crBox_ = new Rectangle(offset.left, offset.top, jScaleBar.width(), jScaleBar.height()); /// actually do this at any new positioning
    } else {
      // rotate the scale bar back to 0 to get the initial crBox_
      var thisAngleRad = angleDeg * us.Deg2Rad;

      crBox_ = divRotate(jScaleBar[0], 0, 0, jScaleBar.width(), jScaleBar.height(), 0);
      offset = jScaleBar.offset();
      crBox_.offset(offset.left, offset.top);
      // return the scale bar to its rotated angle
      divRotate(jScaleBar[0], 0, 0, jScaleBar.width(), jScaleBar.height(), thisAngleRad);
    }
    return crBox_;
  };

    // ............................................ load_() local
    //    This function loads/creates the scale bar and calls into the layout manager
    //        to position it according to its layout settings.
  var load_ = function () {
    if (jScaleBar) return; // if this viewport already has a scale bar, return
    jScaleBar = jVpDiv.find('.' + us.clsDIVSCALEBAR); // select the scale bar
    if (jScaleBar.length) return; // if a match was found, return

    var mag = viewport.getViewMag();
    var baseMag = viewport.getBaseMag();

    var initPosX = 0;
    var initPosY = 0; // initial position does not matter if using layout control

    var scaleDef = scaleBarSpecs.micronsAt20x;
    if (baseMag > 80) scaleDef = scaleBarSpecs.micronsAt100x;
    else if (baseMag > 30) scaleDef = scaleBarSpecs.micronsAt40x;

    var scaleLenMic = scaleDef * viewport.getViewZoom(); // start with a default length in microns
    scaleLenMic = Math.round(scaleLenMic / scaleDef) * scaleDef;
    scaleLenMicCur_ = scaleLenMic; // save the current scale bar length in microns
    bIsFitZoomCur_ = viewport.isFitZoom(); // save whether the current zoom is fit or not

    var MPP = viewport.getBaseMPP() * viewport.getViewZoom(); // microns/pixel = base level microns/pixel x current zoom
    var scaleBarLenPx = (scaleLenMic / MPP); // scale bar length in pxiels - for this zoom

    jScaleBarOuter = $('<div/>', { // build the outer scale bar div
      'class': us.clsDIVOUTERSCALEBAR + ' ' + us.clsOVERLAY,
      'title': $t('ui-title'),
      css: {
        'left': initPosX + 'px',
        'top': initPosY + 'px'
      }
    });

    jScaleBar = $('<div/>', { // build the inner scale bar div
      'class': us.clsDIVSCALEBAR,
      css: {
        'width': scaleBarLenPx + 'px'
      }
    });

    // note that the text must be in its own div or the resize handle gets hidden
    jMagDiv = $('<span/>', {'class': us.clsDIVSCALEMAG, text: mag + 'x'});
    if (bReportPixels_) {
      jTextDiv = $('<span/>', {'class': us.clsDIVSCALETEXT, text: ' ' + Math.round(scaleBarLenPx) + ' px'});
    } else {
      jTextDiv = $('<span/>', {'class': us.clsDIVSCALETEXT, text: ' ' + scaleLenMic + ' um'});
    }

    jRotateKnob = $('<div/>', {
      'class': us.clsSBROTKNOB,
      'title': `${$t('rotate-nob-message')}`
    });
    jKnobText = $('<div/>', {'class': us.clsSBROTKNOBANGLE});

    if (viewport.getCaptureType() == us.eAICCaptureType.aic_i_FL) { // if image is FL change styles for visibility
      jScaleBar.css({'color': '#fff'});
      jTextDiv.css({'background-color': '#111', 'border': '2px solid #fff', 'border-bottom': 'hidden'});
      jMagDiv.css({'background-color': '#666'});
      jRotateKnob.css({'background-color': '#111', 'border': '2px solid #fff', 'border-bottom': 'hidden'});
    }

    jScaleBar.append(jMagDiv); // place the mag text div in the scaleBar
    jScaleBar.append('<div class="scaledivider"></div>'); // horizontal break
    jScaleBar.append(jTextDiv); // place the scale text div in the scaleBar

    jRotateKnob.append(jKnobText);
    jScaleBar.append(jRotateKnob); // place the rotation knob div in the scaleBar

    jScaleBarOuter.append(jScaleBar); // place the inner scale bar div in its outer
    jVpDiv.append(jScaleBarOuter); // place the outer scale bar div in the viewport

    viewport.overLayout.add(layout); // and call into layout with parms to place the div
    crBoxSet_(); // initialize the bounding box

    isLoaded = true;
    self.show(true); // show/hide according to user preferences
    bindEvents_(); // add event handlers

    // ..................................................
    // closure functions
    // ............................................ bindEvents_()
    // bindEvents_ - This function adds the scale bar event handlers.
    //
    //    Note that by using the same namespace as the viewport when the
    //    viewport removes its events by namespace, these are also removed.

    function bindEvents_ () {
      var namespace = viewport.eventNameSpaceGet();

      // show/hide scaleBar on mode change
      $(us.idHashROOT).on(us.evMODECHANGE + namespace, function (e, parms) {
        // show is true unless the navMode is one that the scale bar is supposed to hide during
        var bshow = (navModesImHiddenIn[parms.navMode] == undefined);
        self.show(bshow);
      });

      viewport.renderer.addLayer({
        zoomChange: self.resize.bind(self, 'zoom')
      });

      // show/hide scaleBar if image is selected/not-selected
      $(us.idHashROOT).on(us.evIMAGESELECTED + namespace, function (e, parms) {
        // show is true unless the navMode is one that the scale bar is supposed to hide during
        var bshow = (navModesImHiddenIn[parms.navMode] == undefined);
        self.show(bshow);
      });

      // user preference update
      $(us.idHashROOT).on(us.evUSERPREFSREADY + namespace, function (e, parms) {
        self.show(userConfig.get(us.clsDIVSCALEBAR));
      });
      $(us.idHashROOT).on(us.evUSERPREFSET + namespace, function (e, parms) { // parms: {className: STR, value: bool}
        if (parms.className == us.clsDIVSCALEBAR) {
          self.show(parms.value);
        }
      });

      // ..................................................  scale bar drag and resize related
      jScaleBarOuter.draggable({
        cursor: 'move',
        containment: 'parent',
        stop: function (event, ui) {
          crBoxSet_(); // update sb bounding box so public call has box up to date
          layout.canBePlaced = false; // reposition only when scalebar is not fully within view
        }
      });

      jScaleBar.resizable({
        cursor: 'move',
        handles: 'e,w',
        distance: 0,
        alsoResize: jScaleBarOuter,
        resize: function (e) {
          self.resize('resize');
          return false;
        },
        stop: function (event, ui) {
          crBoxSet_();
        }
      });

      jScaleBar.on('mouseover' + namespace, function (e) { // ..... mouseover event adds the scalebar's resize handles
        if ($(this).attr('hasHandles') == undefined) {
          $(this).attr('hasHandles', true);
          var jchildren = $(this).eq(0).children();
          jchildren.each( //
            function (idx) {
              var aclass = $(this).attr('class');
              if (aclass.indexOf('ui-resizable-e') != -1 || aclass.indexOf('ui-resizable-w') != -1) {
                $(this).addClass('ui-icon ui-icon-grip-solid-vertical');
              }
            });
        }
      });

      // ..................................................  scale bar rotation related

      { // configure rotation
        const resetToZero = function (e) { // set rotation to 0 degrees and place in default location
          layout.canBePlaced = true; // allow layout to reposition the scalebar again
          self.rotate(0, 'absolute');
          reLayout(layout.precinct); // layout just this overlay's precinct
          e.preventDefault();
          return false;
        };
        const doHaltNav = function (e) { // ...... mouse up on knob or scale bar (or viewport) halts navigation
          if (viewport.navModeGet() == us.eNavModes.nmRotatingOverlay) {
            viewport.navModeHalt();
            return false;
          }
        };

        // ...... hover on knob shows rotation angle
        jRotateKnob.on('hover' + namespace, function (e) {
          if (e.type == 'mouseover' || e.type == 'mouseenter') {
            jKnobText.show();
            angleTextWrite_();
          } else { // e.type == 'mouseout' 'mouseleave'
            jKnobText.hide();
          }
          return false;
        });

        jRotateKnob.on('mousedown' + namespace, function (e) { // ...... mouse down on knob starts rotation
          viewport.navModeSwitch(us.eNavModes.nmRotatingOverlay);
          crBoxSet_(); // initialize the scale bar's bounding box at the start of rotation
          return false;
        });

        jRotateKnob.on('dblclick' + namespace, resetToZero);
        jKnobText.on('dblclick' + namespace, resetToZero);
        jKnobText.on('click' + namespace, resetToZero);

        jRotateKnob.on('mousemove' + namespace, self.rotateToCursor);
        jScaleBar.on('mousemove' + namespace, self.rotateToCursor);

        jRotateKnob.on('mouseup' + namespace, doHaltNav);
        jScaleBar.on('mouseup' + namespace, doHaltNav);
      }
    }
    // ..................................................
  };
    // ............................................ construction.
  construct_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/scalebar/scalebar-control.js